import {
  CheckboxGroupInput,
  Datagrid,
  DateField,
  Filter,
  FunctionField,
  TextField,
  TextInput,
} from 'react-admin'

import {
  ContactedLoadStatus,
  ContactedLoadStatusChoices,
  LABEL_ORIGIN_TO_DESTINATION,
  LABEL_PICKUP_DATE,
  ORIGIN,
} from '../../helpers/constants'
import { getLoadStop, getUserFullName } from '../../helpers/utils'
import { CustomReferenceField } from '../Common/CustomReferenceFields'
import { LocalizedStopDateTimeField, OriginDestinationField } from '../Fields'
import CTList from '../List'

const ContactedLoadFilter = (props: any) => (
  <Filter {...props}>
    <TextInput label="Search" source="search" alwaysOn />
    <CheckboxGroupInput label="Status" source="status" choices={ContactedLoadStatusChoices} alwaysOn />
  </Filter>
)

const ContactedLoadsList = (props: any) => (
  <CTList
    bulkActionButtons={false}
    filters={<ContactedLoadFilter />}
    filterDefaultValues={{ status: [ContactedLoadStatus.Contacted] }}
    title="Contacted Loads"
    {...props}
  >
    <Datagrid optimized rowClick="show">
      <DateField
        source="date_created"
        label="Date Contacted"
        options={{ timeZoneName: 'short' }}
        showTime={true}
      />
      <TextField source="load.source" label="Source" sortable={false} />
      <TextField source="load.source_human_id" label="Source ID" sortable={false} />
      <TextField source="load.broker.name" label="Broker" />
      <FunctionField
        label={LABEL_PICKUP_DATE}
        sortBy="load__origin_pickup_date"
        render={(record: any) => (
          <LocalizedStopDateTimeField record={getLoadStop(record.load, ORIGIN)} source="date_start" />
        )}
      />
      <FunctionField
        label={LABEL_ORIGIN_TO_DESTINATION}
        sortable={false}
        render={(record: any) => {
          return <OriginDestinationField record={record.load} />
        }}
      />
      <CustomReferenceField
        source="created_by"
        sortable={false}
        label="Created By"
        baseUrl="/users"
        representationFunction={getUserFullName}
      />
      <TextField source="status" label="Status" sortable={false} />
    </Datagrid>
  </CTList>
)

export default ContactedLoadsList
